const projectColumns = () => [
  {
    dataField: "id",
    text: "#",
    sort: true,
  },
  {
    dataField: "name",
    text: "Name",
    sort: true,
  },
  {
    dataField: "startDate",
    text: "Start Date",
    sort: true,
  },
  {
    dataField: "deadline",
    text: "Deadline",
    sort: true,
  },
  {
    dataField: "budget",
    text: "Budget",
    sort: true,
  },
]

export default projectColumns
